import StyledButtonChildren from './__styled__/StyledButtonChildren';

interface ButtonChildrenProps {
  children: React.ReactNode;
  $secondary?: boolean;
  $inverted?: boolean;
  $inline?: boolean;
  $hiddenText?: boolean;
  $icon?: React.ReactNode | null;
  $iconAfter?: React.ReactNode | null;
  $wideUnderline?: boolean;
  disabled?: boolean;
  $leftAlignedTextWithIconAfter?: boolean;
}

export default function ButtonChildren({
  children,
  $secondary = false,
  $inverted = false,
  $inline = false,
  $hiddenText = false,
  $icon = null,
  $iconAfter = null,
  $wideUnderline = false,
  disabled = false,
  $leftAlignedTextWithIconAfter = false,
}: ButtonChildrenProps) {
  return (
    <StyledButtonChildren
      $secondary={$secondary}
      $inverted={$inverted}
      $inline={$inline}
      $hiddenText={$hiddenText}
      $icon={$icon}
      $iconAfter={$iconAfter}
      $wideUnderline={$wideUnderline}
      disabled={disabled}
      $leftAlignedTextWithIconAfter={$leftAlignedTextWithIconAfter}
    >
      {children}
    </StyledButtonChildren>
  );
}
